import { observer } from "mobx-react";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import { IOption, SelectDropdown } from "../../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { ICompareValueTypeComponentProps } from "../condition-field";
import WeightCompareValueStore from "../../../../../../../stores/compare-value/weight-compare-value-store";

const WeightCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: WeightCompareValueStore = store as WeightCompareValueStore;

    const options = compareValueStore.options as IOption[]
    const selectedOption = options.find(o => o.value === compareValueStore.type);

    return (
        <>
            {operatorSelector}

            <Input disabled={!condition.isEditMode} type={'number'} value={compareValueStore.value} min={0} onChange={(v) => compareValueStore.setValue(v)} placeholder="0" />

            <SelectDropdown disabled={!condition.isEditMode} value={selectedOption} options={options} onChange={e => compareValueStore.setType(e?.value.toString() ?? '')} isSearchable={false} />      
        </>
    );
});

export default WeightCompareValueField;